export const formatNumber = (value) => {
  if (value === "-" || value === 0 || value === "0" || value === "N/A") {
    return "0";
  }
  if (value === "OT Abierta") {
    return value;
  }
  return new Intl.NumberFormat().format(value);
};

export const formatDate = (value) => {
  if (value === "Pendiente" || !value) {
    return value || "N/A";
  }
  // return new Date(value).toLocaleDateString("es-CL");
  const [year, month, day] = value.split("-");
  return `${day}-${month}-${year}`;
};

export const formatCurrency = (value) => {
  if (value === "Sin costo asociado" || value === "Sin cargo asociado") {
    return value;
  }
  return new Intl.NumberFormat("es-CL", {
    style: "currency",
    currency: "CLP",
  }).format(value);
};

export const normalizeName = (name) => {
  if (typeof name !== "string" || !name) return "";

  if (/[ÃÂ]/.test(name)) {
    try {
      const bytes = Uint8Array.from(
        [...name].map((char) => char.charCodeAt(0))
      );
      const decoded = new TextDecoder("utf-8").decode(bytes);
      if (decoded) return decoded;
    } catch (error) {
      console.warn("Error normalizing name:", error);
    }
  }

  return name;
};
